export default [
  {
    title: "Home",
    icon: "HomeIcon",
    tagVariant: "light-warning",
    route: "home-flyGate",
    resource: "Home",
    action: "View",
  },
  // {
  //   title: "Alert Message",
  //   icon: "AlertTriangleIcon",
  //   tagVariant: "light-warning",
  //   route: "alertMessage-flyGate",
  //   resource: "Home",
  //   action: "View",
  // },
  {
    title: "Dashboard",
    icon: "ActivityIcon",
    tagVariant: "light-warning",
    route: "dashboard-flyGate",
    resource: "Dashboard",
    action: "read",
  },
];
